import { IFormatDataParams } from "@home/utils/dbDataFormat/_type";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";

/**
 * @description 确保百分比小于 0.1% 时展示为 <0.1% 而不是展示 0%
*/
export const formatPercent = (formatData: IFormatDataParams): string => {
  const { value } = formatData;
  const formattedData = dataFormat(formatData);

  if (formatData.formatRule === 'percent2Decimal') {
    if (typeof formattedData === 'string') {
      const percentNum = parseFloat(formattedData.replace('%', ''));
      if (Number.isNaN(percentNum)) {
        return formattedData;
      }
  
      if (
        typeof value === 'number' ||
        (typeof value === 'string' && !Number.isNaN(Number(value)))
      ) {
        const percentage = Number(value) * 100;
        if (percentage < 0.1 && percentage > 0) {
          return '<0.1%';
        }
      }
    }
  }

  return String(formattedData);
};